import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { useLang } from "../i18n";

const SECTIONS = [
  {
    hi: { h: "जानकारी का संग्रह", p: "जब आप हमारे संपर्क या स्वयंसेवक फॉर्म भरते हैं, तो हम केवल आपका नाम, संपर्क विवरण और संदेश प्राप्त करते हैं। यह जानकारी केवल आपसे संपर्क करने के उद्देश्य से उपयोग की जाती है।" },
    en: { h: "Information Collection", p: "When you fill our contact or volunteer form, we only receive your name, contact details and message. This information is used solely to communicate with you." },
  },
  {
    hi: { h: "जानकारी का उपयोग", p: "आपकी जानकारी किसी तीसरे पक्ष को बेची या साझा नहीं की जाती है। दान से संबंधित कोई भी कार्ड या UPI जानकारी हमारे सर्वर पर संग्रहीत नहीं की जाती।" },
    en: { h: "Use of Information", p: "Your information is never sold or shared with third parties. No card or UPI credentials related to donations are stored on our servers." },
  },
  {
    hi: { h: "दान सुरक्षा", p: "दान केवल वेबसाइट पर दिए गए आधिकारिक QR कोड, UPI ID या बैंक खाते के माध्यम से ही करें। किसी अनौपचारिक खाते में भुगतान न करें।" },
    en: { h: "Donation Security", p: "Donate only through the official QR code, UPI ID or bank account given on this website. Never pay into unofficial accounts." },
  },
  {
    hi: { h: "संपर्क", p: "गोपनीयता नीति संबंधी किसी भी प्रश्न के लिए हमसे ananshawelfaresociety@gmail.com या +91 9452529739 पर संपर्क करें।" },
    en: { h: "Contact", p: "For any questions about this privacy policy, contact us at ananshawelfaresociety@gmail.com or +91 9452529739." },
  },
];

export default function PrivacyPolicy() {
  const { lang } = useLang();
  return (
    <main>
      <Seo
        title="गोपनीयता नीति"
        description="Anansha Welfare Society की गोपनीयता नीति — आपकी जानकारी का संग्रह, उपयोग और दान सुरक्षा।"
        path="/privacy-policy"
        breadcrumb={["गोपनीयता नीति"]}
      />
      <PageHero
        overline={{ hi: "नीति", en: "Policy" }}
        title={{ hi: "गोपनीयता नीति", en: "Privacy Policy" }}
        testid="privacy-page-heading"
      />
      <section className="py-20 bg-ngo-cream">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 space-y-8">
          {SECTIONS.map((s, i) => (
            <Reveal key={i} i={i}>
              <div data-testid={`privacy-section-${i}`}>
                <h2 className="font-heading font-bold text-2xl text-ngo-ink">{lang === "hi" ? s.hi.h : s.en.h}</h2>
                <p className="mt-3 text-base leading-relaxed text-ngo-ink/70">{lang === "hi" ? s.hi.p : s.en.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
